import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { StaffClockOutPrint } from '../components/Buttons/StaffClockOutPrint';
import { useReactToPrint } from 'react-to-print';
import reportApis from 'features/report/services/apis';
import { useSetLoadingPage } from 'services/UI/LoadingPage';
import { AxiosResponse } from 'axios';
import { IStaffPayrollPrintData } from 'features/report/services/types/reportStaff';
import dayjs from 'dayjs';

type IStaffClockOutPrintManagerProps = {};
type IStaffClockOutPrintManagerRef = {
  open: (staffId: string) => Promise<void>;
};
export const StaffClockOutPrintManagerRef = React.createRef<IStaffClockOutPrintManagerRef>();
const StaffClockOutPrintManagerContext = forwardRef<IStaffClockOutPrintManagerRef, IStaffClockOutPrintManagerProps>((props, ref) => {
  const callbackResolve = useRef<() => void>(() => undefined);
  const printRef = useRef<HTMLDivElement>(null);
  const setLoadingPage = useSetLoadingPage();
  const [staffPayrollData, setStaffPayrollData] = useState<IStaffPayrollPrintData[]>([]);

  const onPrint = useReactToPrint({
    content: () => printRef.current,
    copyStyles: true,
    onAfterPrint() {
      callbackResolve.current?.();
    },
  });

  const handleOpen: IStaffClockOutPrintManagerRef['open'] = async (staffId: string) => {
    setLoadingPage(true);
    try {
      const res: AxiosResponse<{ data: IStaffPayrollPrintData[] }> = await reportApis.getReportSalaryStaff({
        staffId,
        startDate: dayjs().startOf('day').format('MM-DD-YYYY'),
        endDate: dayjs().endOf('day').format('MM-DD-YYYY'),
      });
      if (res.data.data && res.data.data.length > 0) {
        setStaffPayrollData(res.data.data);
        setTimeout(() => onPrint(), 100);
      }
    } catch (error) {
      setStaffPayrollData([]);
    } finally {
      setLoadingPage(false);
    }

    return new Promise((resolve) => {
      callbackResolve.current = resolve;
    });
  };


  useImperativeHandle(ref, () => ({
    open: handleOpen,
  }));

  return (
    <>
      <div style={{ display: 'none' }}>
        <div ref={printRef}>
          <StaffClockOutPrint
            params={{
              startDate: dayjs().startOf('day').format('MM-DD-YYYY'),
              endDate: dayjs().endOf('day').format('MM-DD-YYYY'),
            }}
            staffPayrollData={staffPayrollData}
          />
        </div>
      </div>
    </>
  );
});

StaffClockOutPrintManagerContext.displayName = 'StaffClockOutPrintManagerContext';
const StaffClockOutPrintManager = {
  Portal: () => <StaffClockOutPrintManagerContext ref={StaffClockOutPrintManagerRef} />,
  open: (staffId: string) => StaffClockOutPrintManagerRef.current?.open(staffId),
};

export default StaffClockOutPrintManager;

